export default __webpack_public_path__ + "logo-dark-small.883096c2cbb1f70651b14e6548b55e8b.svg";